import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { LOGIN_URL } from "@constants/routes";
import { logOutReduxRequest } from "@redux-requests/log-out/log-out";
import { getHostnameWithScheme } from "@utils/http-util";
import { LoadingIndicator } from "../common/loading-indicator/loading-indicator";
import styles from "./logout-container.less";

export const LogoutContainer = () => {
    const dispatch = useDispatch();

    const logout = async () => {
        await logOutReduxRequest(dispatch)();
        const loginUrl = `${getHostnameWithScheme()}${LOGIN_URL}`;
        window.location.href = loginUrl;
    };

    useEffect(() => {
        logout();
    }, []);

    return (
        <div className={styles.logoutContainer}>
            <LoadingIndicator title="Logging out" />
        </div>
    );
};